// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"fbac8569","752":"4df6aff2"}[chunkId] + ".chunk.js";
};